import {
  BulkCreatedOrderItem,
  BulkValidationCheck,
  ExpectedDocumentItem,
  OrderBulkCreateResult,
  OrderBulkValidateResult,
} from '../../domain/entities/order-bulk.entity';

export interface BulkValidationCheckApiResponse {
  checkName: string | null;
  isOk: boolean;
  errors: string[] | null;
}

export interface ExpectedDocumentItemApiResponse {
  requestReference: string | null;
  documentName: string | null;
  documentType: string | null;
}

export interface OrderBulkValidateApiResponse {
  isValid: boolean;
  checks: BulkValidationCheckApiResponse[] | null;
  expectedDocuments: ExpectedDocumentItemApiResponse[] | null;
}

export interface BulkCreatedOrderItemApiResponse {
  reference: string | null;
  orderId: string;
}

export interface OrderBulkCreateApiResponse {
  totalCreated: number;
  createdOrders: BulkCreatedOrderItemApiResponse[] | null;
}

export class OrderBulkMapper {
  static toValidateDomain(response: OrderBulkValidateApiResponse): OrderBulkValidateResult {
    return {
      isValid: response.isValid,
      checks: (response.checks ?? []).map((c): BulkValidationCheck => ({
        checkName: c.checkName ?? '',
        isOk: c.isOk,
        errors: c.errors ?? [],
      })),
      expectedDocuments: (response.expectedDocuments ?? []).map((d): ExpectedDocumentItem => ({
        requestReference: d.requestReference ?? '',
        documentName: d.documentName ?? '',
        documentType: d.documentType ?? '',
      })),
    };
  }

  static toCreateDomain(response: OrderBulkCreateApiResponse): OrderBulkCreateResult {
    return {
      totalCreated: response.totalCreated,
      createdOrders: (response.createdOrders ?? []).map((o): BulkCreatedOrderItem => ({
        reference: o.reference,
        orderId: o.orderId,
      })),
    };
  }
}
